



































/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ArticleSearch from "@/Views/Articles/ArticleSearch.vue";

import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../Models/Buttons";
import { ContentSearchHit, ArticleType, SyndicationArticleDto, ArticleModelArticleType, CustomerArticleLicenceDTO } from "../../Generated/ParticaAPI";
import ArticleActions from "@/Ui-Components/Article/Actions/ArticleActions.vue";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import ParticaAccountBase from "../Base/ParticaAccountBase.vue";
import ParticaArticlePreview from "../../Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import { IArticle, Article, IWrittenArticle } from "../../Models/ArticleModels/article";
import { IArticleService } from "../../BusinessServices/article";
import ParticaArticleProof from "../../Ui-Components/Article/Edit/ParticaArticleProof.vue";
import { ISyndicationArticleService } from "../../BusinessServices/syndication";
import { IWrittenArticleService } from "../../BusinessServices/writtenarticles";
import ViewArticleLicence from "@/Ui-Components/ArticleLicence/ViewArticleLicence.vue";
import { IArticleLicenceService } from "../../BusinessServices/accountlicence";
import { IParticaStoreService } from "../../BusinessServices/particastore";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";



const namespace: string = "config";

@Component(
	{
		name: "AccountArticles",
		components: {
			ParticaRowContainer,
			ParticaCard,
			ArticleSearch,
			ArticleActions,
			ParticaDialogCard,
			ParticaView,
			ParticaArticlePreview,
			ParticaArticleProof,
			ViewArticleLicence,
			ParticaRightDrawer
		}
	})
export default class AccountArticles extends ParticaAccountBase {
	@Prop() private id: number;
	private query: string = "";
	private articlesvc: IArticleService;
	private syndicationArticleService: ISyndicationArticleService;
	private writtenArticleService: IWrittenArticleService;
	private selectedArticle: ContentSearchHit = new ContentSearchHit();
	private showactions: boolean = false;
	private showpreview: boolean = false;
	private showlicence: boolean = false;
	private licence: CustomerArticleLicenceDTO = new CustomerArticleLicenceDTO();
	private storeService: IParticaStoreService;

	private previewbuttons: ButtonConfig[] = [
	];


	private showproof: boolean = false;
	private proofbuttons: ButtonConfig[] = [
	];
	private article: IArticle = new Article();
	private facets: string[] = [
		"publication",
		"issue",
		"article_type",
		"themes"
	];

	private propchanged: boolean = false;

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.VIEW_ARTICLE_LICENCE: {
					const selected: ContentSearchHit = event.item as ContentSearchHit;
					this.licence = await this.storeService.getCurrentArticleLicence(selected.articleId as string);
					this.showlicence = true;
					this.showactions = false;
					break;
				}
				case eParticaAction.ARTICLE_EDIT: {
					this.propchanged = false;
					this.proofbuttons = [];
					const selected: ContentSearchHit = event.item as ContentSearchHit;
					this.licence = await this.storeService.getCurrentArticleLicence(selected.articleId as string);
					this.article = await this.articlesvc.getArticle(selected);
					switch (this.article.articleType) {
						case ArticleModelArticleType.Written: {
							const saveButton: ButtonConfig = {
								label: "Save Article",
								action: eParticaAction.ARTICLE_SAVE,
								type: ButtonType.OK,
								status: ButtonStatus.Disabled
							} as ButtonConfig;
							this.proofbuttons.push(saveButton);
							const moveProofButton = {
								label: "Move to Proof",
								action: eParticaAction.ARTICLE_MOVE_PROOF,
								type: ButtonType.Normal,
								status: ButtonStatus.Enabled
							} as ButtonConfig;
							this.proofbuttons.push(moveProofButton);
							break;
						}
						case ArticleModelArticleType.Syndicationproof: {
							const saveButton: ButtonConfig = {
								label: "Save Article",
								action: eParticaAction.ARTICLE_SAVE,
								type: ButtonType.OK,
								status: ButtonStatus.Disabled
							} as ButtonConfig;
							this.proofbuttons.push(saveButton);
							const moveProofButton = {
								label: "Approve",
								action: eParticaAction.ARTICLE_APPROVE,
								type: ButtonType.Normal,
								status: ButtonStatus.Enabled
							} as ButtonConfig;
							this.proofbuttons.push(moveProofButton);
							break;
						}
					}
					this.showactions = false;
					this.showproof = true;
					break;
				}
				case eParticaAction.ARTICLE_MOVE_PROOF: {
					const moveDto: SyndicationArticleDto = new SyndicationArticleDto();
					moveDto.articleId = this.article.articleId;
					moveDto.issueId = this.article.issueId;
					const warnings: string[] = await this.syndicationArticleService.moveArticleToProof(moveDto);
					if (warnings.length > 0) {
						let msg: string = "";
						warnings.forEach(warning => {
							msg += warning + "\n";
						});
						this.ShowSnackbar(msg);
					} else {
						this.SetButtonStatus(this.proofbuttons, eParticaAction.ARTICLE_MOVE_PROOF, ButtonStatus.Disabled);
						this.ShowSnackbar(`'${this.article.title}' moved to syndication proof.`);
					}
					this.showproof = false;
					break;
				}
				case eParticaAction.ARTICLE_APPROVE: {
					const moveDto: SyndicationArticleDto = new SyndicationArticleDto();
					moveDto.articleId = this.article.articleId;
					moveDto.issueId = this.article.issueId;
					const warnings: string[] = await this.syndicationArticleService.approveArticle(moveDto);
					if (warnings.length > 0) {
						let msg: string = "";
						warnings.forEach(warning => {
							msg += warning + "\n";
						});
						this.ShowSnackbar(msg);
					} else {
						this.SetButtonStatus(this.proofbuttons, eParticaAction.ARTICLE_APPROVE, ButtonStatus.Disabled);
						this.ShowSnackbar(`'${this.article.title}' moved to syndication.`);
					}
					this.init();
					break;
				}
				case eParticaAction.ARTICLE_SELECT: {
					this.selectedArticle = event.item as ContentSearchHit;
					this.showactions = true;
					break;
				}
				case eParticaAction.ARTICLE_SAVE: {
					this.SetButtonStatus(this.proofbuttons, eParticaAction.ARTICLE_SAVE, ButtonStatus.Disabled);
					switch (this.article.articleType) {
						case ArticleModelArticleType.Written: {
							this.article = await this.writtenArticleService.saveArticle(this.article as unknown as IWrittenArticle, 0) as unknown as IArticle;
							this.SetButtonStatus(this.proofbuttons, eParticaAction.ARTICLE_MOVE_PROOF, ButtonStatus.Enabled);
							break;
						}
						case ArticleModelArticleType.Syndicationproof: {
							this.article = await this.syndicationArticleService.saveArticle(this.article);
							this.SetButtonStatus(this.proofbuttons, eParticaAction.ARTICLE_APPROVE, ButtonStatus.Enabled);
							break;
						}
					}
					this.propchanged = false;
				}
				case eParticaAction.PROPERTY_CHANGED: {
					if (this.propchanged === false) {
						this.propchanged = true;
						this.SetButtonStatus(this.proofbuttons, eParticaAction.ARTICLE_SAVE, ButtonStatus.Enabled);
					}
					break;
				}
				case eParticaAction.ARTICLE_PREVIEW: {
					const selected: ContentSearchHit = event.item as ContentSearchHit;
					this.article = await this.articlesvc.getArticle(selected);
					this.showpreview = true;
					break;
				}
				case eParticaAction.CLOSE_DIALOG: {
					this.showactions = false;
					break;
				}
				case eParticaAction.ISSUE_SELECT: {
					this.selectedArticle = event.item as ContentSearchHit;
					if (this.selectedArticle !== undefined && this.selectedArticle.issueId !== undefined) {
						switch (this.selectedArticle.articleType) {
							case 1: { // metadata
								this.navigate("issuemanagemeta", { id: this.selectedArticle.issueId.toString() });
								break;
							}
							case 0: // extracted
							case 4: // copied
							case 9: { // imported
								this.navigate("issuemanagearticles", { id: this.selectedArticle.issueId.toString() });
								break;
							}
							default: {
								this.navigate("issue", { id: this.selectedArticle.issueId.toString() });
							}
						}
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Account Articles";
		this.articlesvc = this.particaServices.getArticleService();
		this.syndicationArticleService = this.particaServices.getSyndicationArticleService();
		this.writtenArticleService = this.particaServices.getWrittenArticleService();
		this.storeService = this.particaServices.getParticaStoreService();
		await this.init();

	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getAccountNav(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
